// extracted by mini-css-extract-plugin
export var border = "_i-8";
export var brand = "_i-t";
export var button = "_i-l";
export var center = "_i-a";
export var centered = "_i-6";
export var closeButton = "_i-c";
export var disabledWrapper = "_i-m";
export var error = "_i-p";
export var extraLarge = "_i-4";
export var extraSmall = "_i-1";
export var fill = "_i-i";
export var footer = "_i-h";
export var footerAction = "_i-j";
export var footerButtons = "_i-k";
export var header = "_i-7";
export var headerWithClose = "_i-d";
export var icon = "_i-o";
export var info = "_i-s";
export var inline = "_i-9";
export var large = "_i-3";
export var main = "_i-e";
export var modal = "_i-0";
export var nearFull = "_i-5";
export var neutral = "_i-u";
export var noPadding = "_i-g";
export var none = "_i-v";
export var scrollable = "_i-f";
export var small = "_i-2";
export var success = "_i-r";
export var tight = "_i-n";
export var titleIcon = "_i-b";
export var warn = "_i-q";